import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

function LoadingSpin({ fontSize, color }: any) {
  const antIcon = (
    <LoadingOutlined
      style={{ fontSize: fontSize, color: color }}
      spin
      rev={undefined}
    />
  );
  return <Spin indicator={antIcon} />;
}

export default LoadingSpin;
